import { WorkType } from '@adminModels';
import { PaginationMetadata } from '@shared';

export interface WorkTypesState {
  workTypes: WorkType[];
  loading: boolean;
  error: string | null;
  pagination: PaginationMetadata;
}

export const initialWorkTypesState: WorkTypesState = {
  workTypes: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};
